<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 15:35:08
 * @LastEditTime: 2020-06-18 11:45:21
 * @Description: 简答作答区域
-->
<template>
  <div class="short-area">
    <!-- <i-input
      :value="userAnswer"
      type="textarea" :rows="5" @on-change="userAnswerChanged" /> -->

    <div
      class="short-area-item"
      :class="focus ? 'active' : ''">
      <textarea type="text" rows="6"
        :value="userAnswer"
        @input="userAnswerChanged"
        @focus="textInputFocus()"
        @blur="textInputBlur()" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';

export default {
  name: 'ShortArea',
  props: {
    type: { type: String, required: true },
    index: { type: Number, required: true },
    timeRemaining: { type: String, required: true },
  },
  data() {
    return {
      userAnswer: '',
      focus: false,
    };
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
    question() {
      return this.libraryInfo[this.index];
    },
    options() {
      return this.question.libraryVo.options;
    },
    answer() {
      return this.question.answer;
    },
  },
  watch: {
    answer: {
      immediate: true,
      handler(answer) {
        this.userAnswer = answer;
      },
    },
  },
  methods: {
    ...mapActions({
      setLibraryInfo: 'onlineExamStore/invokeSetLibraryInfo',
    }),
    /**
     * 答题区域内容发生改变
     */
    userAnswerChanged(e) {
      this.userAnswer = e.target.value;
      this.requestSaveAnswerAndSetting();
    },
    textInputFocus() {
      this.focus = true;
    },
    textInputBlur() {
      this.focus = false;
    },
    /**
     * 请求保存答题信息并设置
     */
    requestSaveAnswerAndSetting: debounce(function () {
      this.requestSaveAnswer()
        .then(() => {
          const libraryInfo = JSON.parse(JSON.stringify(this.libraryInfo));

          libraryInfo[this.index].answer = this.userAnswer;

          this.setLibraryInfo({ libraryInfo });
        })
        .catch((result) => {
          alert(result.msg);

          if (result.msg === '您已在另一终端进入考试') {
            window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
          }
        });
    }, 500),
    /**
     * 请求保存答题信息
     */
    requestSaveAnswer() {
      const params = {
        id: this.question.id,
        answer: this.userAnswer,
        remainingTime: this.timeRemaining,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.saveAnswer(params);
        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.short-area {
  margin-top: 12px;
  width: 100%;

  &-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 420px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background-color: rgba(12, 140, 202, 0.08);
    color: #0C8CCA;
    border-radius: 4px;
    font-size: 14px;
    overflow: hidden;

    &.active {
      position: relative;
      background-color: rgba(12, 140, 202, 0.08);
      color: #0C8CCA;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1.2px solid #0C8CCA;
        border-radius: 4px;
      }

      > .suffix {
        display: block;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    .prefix {
      margin-right: 12px;
      font-weight: bold;
    }

    textarea {
      flex: 1;
      background-color: transparent;
      border: none;
      outline: none;
      resize: none;
    }
  }
}
</style>
